import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import ImageModalEquip from "../Modal/ImageModalProd";
import axios from "axios";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const LoginBanner = ({
  helpData,
  setHelpData,
  originalHelpData,
  handleHelpSubmit
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const url = API_BASE_URL
  // Set default values if helpData is null/undefined
  const safeHelpData = helpData || { email_id: "", pass_id: "" };
  const [images, setImages] = useState([]);
  const user = getDecryptedUserFromCookie("gta_mainstateuser");
  const token = decryptToken("accessToken") || "";
  const [showImageModal, setShowImageModal] = useState(false);
  const handleImageView = async () => {
    if (!user?.main_id || !token) {
      setImages([]);
      return;
    }
    try {
      const all = await axios.get(`${url}/api/images/${user.main_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setImages((all.data || []).slice().reverse());
    } catch (e) {
      console.warn("Media library load failed:", e?.message || e);
      setImages([]);
    }
  };

  useEffect(() => {
    if (!originalHelpData) return;
    const changed = JSON.stringify(safeHelpData) !== JSON.stringify(originalHelpData);
    setHasChanges(changed);
  }, [safeHelpData, originalHelpData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHelpData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    handleImageView();
  }, [])

  return (
    <div className="profile-form-container">
      {/* Support Phone Number */}
      <div className="profile-form-group">
        <label className="oms-form-label">Banner</label>

        {/* Button to open image modal */}
        <button
          type="button"
          className="image-upload-btn"
          onClick={() => setShowImageModal(true)}
        >
          Choose  Image
        </button>

        {safeHelpData?.image?.length > 0 && (
          <div className="selected-image-preview">
            <img
              src={safeHelpData.image[0]?.url ? `${url}${safeHelpData.image[0].url}` : safeHelpData.image[0]}
              alt="Selected"
            />
            <p
              className='delete-btnomsprod'
              onClick={() => setHelpData((prev) => ({ ...prev, image: [] }))}

            >
              <i class="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </div>
      <ImageModalEquip
        show={showImageModal}
        handleClose={() => setShowImageModal(false)}
        images={images}
        onImageSelect={(img) =>
          setHelpData((prev) => ({ ...prev, image: [img] }))
        }
        // onImageSelect={handleSingleImageSelect}
        multiple={false}
        setImages={setImages}
      />

      {/* Support WhatsApp Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Page</label>
        <select
          name="pass_id"
          value={safeHelpData.pass_id}
          onChange={handleChange}
          className="profile-form-input"
        >
          <option value="">Select Page</option>
          <option value="login">Login</option>
          <option value="register">Register</option>
          <option value="reset-password">Reset Password</option>
        </select>
      </div>

      {/* Save Button */}

      <div className="profile-form-group full-span">
        <button className="profile-save-btn" onClick={handleHelpSubmit}>
          Save Changes
        </button>
      </div>

    </div>
  );
};

export default LoginBanner;
